// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__275So","header":"ClearentDisclaimer_header__2m4d1","inner":"ClearentDisclaimer_inner__3FGO5"};